import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {UserDetailsComponent} from '../user-details/user-details.component';
import {User} from '../../shared/data-objects/user';
import {LoginService} from '../../shared/services/login.service';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-my-details',
  templateUrl: './my-details.component.html',
  styleUrls: ['./my-details.component.css']
})

export class MyDetailsComponent implements OnInit, AfterViewInit {

  @ViewChild('focusInput') focusInputElement: ElementRef;
  @ViewChild('user') user: UserDetailsComponent;

  applicantDetails: User;

  isRequesting: boolean;

  updateErrorMessage: string;
  useSuccessfulStyle: boolean = false;

  constructor(private loginService: LoginService, private router: Router) {
    this.applicantDetails = new User();
  }

  ngOnInit() {
    this.reloadUser();
    this.loginService.refreshToken();
  }

  reloadUser() {
    this.applicantDetails.username = this.loginService.getUser().username;
    this.applicantDetails.title = this.loginService.getUser().title;
    this.applicantDetails.firstName = this.loginService.getUser().firstName;
    this.applicantDetails.lastName = this.loginService.getUser().lastName;
    this.applicantDetails.landLine = this.loginService.getUser().landLine;
    this.user.confirmEmailAddress = this.applicantDetails.email = this.loginService.getUser().email;
    this.applicantDetails.mobile = this.loginService.getUser().mobile;
    this.applicantDetails.accountName = this.loginService.getUser().accountName;
    this.applicantDetails.postalAddress = this.loginService.getUser().postalAddress;
    this.applicantDetails.accountNumber = this.loginService.getUser().accountNumber;
    this.applicantDetails.companyName = this.loginService.getUser().companyName;
    this.applicantDetails.abnNumber = this.loginService.getUser().abnNumber;
  }

  ngAfterViewInit(): void {
    this.focusInputElement.nativeElement.focus();
  }

  get invalid(): boolean {
    return this.user.invalid;
  }

  update(): void {
    this.updateErrorMessage = null;
    this.useSuccessfulStyle = false;
    if (this.invalid) {
      this.updateErrorMessage = 'Please enter required information before submitting the request.';
      return;
    }

    this.isRequesting = true;
    this.loginService.updateUser(this.applicantDetails, true, this.updateOkCb.bind(this), this.updateErrorCb.bind(this));
  }

  updateOkCb(ok: boolean): void {
    this.isRequesting = false;
    this.updateErrorMessage = ok ? 'Your details have been updated successfully.' : 'Server Error';
    this.useSuccessfulStyle = true;
    this.reloadUser();
  }

  updateErrorCb(err: HttpErrorResponse): void {
    this.isRequesting = false;
    if (err) {
      this.updateErrorMessage = err.message;
    } else {
      this.updateErrorMessage = 'Server Error';
    }
  }

  changePassword() {
    this.router.navigate(['/change_password']);
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/my-details/my-details.component.ts